<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalMethodsMixin, globalVariablesMixin } from '../../Mixins/global'
import { ALL_SCORE_PROVIDERS } from '../../Constants/ScoreProviderName'

export default {
  mixins: [mixinComponent, globalVariablesMixin, globalMethodsMixin],

  props: {
    scores: { type: Object, required: true },
    provider: { type: String, required: true },
    creditLimit: { type: [String, Number], default: '' },
    ignoredScores: {
      type: Array,
      required: false,
      default: ['liquidation_score'],
    },
  },

  data: function () {
    return {
      lastScoring: {},
      iconClass: '',
    }
  },

  computed: {
    maxScore() {
      let maxScore = 10

      if (ALL_SCORE_PROVIDERS['informa'].includes(this.lastScore.provider)) {
        maxScore = 20
      } else if (ALL_SCORE_PROVIDERS['creditsafeconnect'].includes(this.lastScore.provider)) {
        maxScore = 100
      }

      return maxScore
    },
    lastScore() {
      return this.scores
        .filter((score) => score.provider === this.provider && !this.ignoredScores.includes(score.type))
        .sort((score, otherScore) => new Date(score.scoreAt) - new Date(otherScore.scoreAt))
        .pop()
    },
    penultimateScore() {
      return this.scores
        .filter(
          (score) =>
            score.provider === this.lastScore.provider &&
            score.type === this.lastScore.type &&
            score.id !== this.lastScore.id,
        )
        .sort((score, otherScore) => new Date(score.scoreAt) - new Date(otherScore.scoreAt))
        .slice(-2)
        .pop()
    },
    lastScoreFormatted() {
      return (
        this.lastScore.provider +
        ' ' +
        this.$root.setDate(this.lastScore.scoreAt) +
        ' : ' +
        this.lastScore.score +
        '/' +
        this.maxScore
      )
    },
    scoreChangeClass() {
      if (!this.penultimateScore) {
        return ''
      }

      //on attribue une variable class à l'icone en fonction du scoring
      if (this.lastScore.score < this.penultimateScore.score) {
        return 'fas fa-arrow-down text-warning'
      } else if (this.lastScore.score > this.penultimateScore.score) {
        return 'fas fa-arrow-up text-success'
      } else if (this.lastScore.score === this.penultimateScore.score) {
        return 'fas fa-minus'
      }

      return ''
    },
  },
}
</script>
<template>
  <div class="row mb-1">
    <div class="col-md-7">
      <b class="mr-1">{{ lastScoreFormatted }}</b>
      <i :class="scoreChangeClass" v-if="scoreChangeClass"></i>
    </div>
    <div class="col-md-5" v-if="creditLimit">
      <b>{{ $t('entity.information.score.limit') }} :</b> {{ $n(Number(creditLimit), 'currency') }}
    </div>
  </div>
</template>
